module.exports = __webpack_public_path__ + "img/westlake.18c92055.png";